import { useMutation } from '@apollo/client/react';
import { Button } from 'components/ui';
import { useInfo } from 'contexts/info';
import { useError } from 'contexts/error';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { PlaceLink } from 'utils/link';
import DeleteMutation from 'mutations/inspection_subject/delete';
import Confirmation from 'components/form/confirmation';

const DeleteButton = ({ inspectionSubject }) => {
  const setInfo = useInfo();
  const setError = useError();
  const navigate = useNavigate();

  const [deleteMutation, deleteMutationData] = useMutation(DeleteMutation, {
    onCompleted: () => {
      setInfo('info.inspection_subject.deleted');
      navigate(PlaceLink(inspectionSubject.place.id));
    },
    onError: () => {
      setError('error.inspection_subject.delete');
    },
  });

  return (
    <Confirmation
      title={<FormattedMessage id="header.inspection_subject.delete" />}
      description={<FormattedMessage id="confirmation.inspection_subject.delete" />}
      onClick={() => {
        deleteMutation({ variables: { id: inspectionSubject.id } });
      }}
    >
      <Button color="error" variant="outlined" disabled={deleteMutationData.loading}>
        <FormattedMessage id="button.delete" />
      </Button>
    </Confirmation>
  );
};

export default DeleteButton;
